import { render, staticRenderFns } from "./Transmit.vue?vue&type=template&id=c01e407c&scoped=true"
import script from "./Transmit.vue?vue&type=script&lang=ts"
export * from "./Transmit.vue?vue&type=script&lang=ts"
import style0 from "./Transmit.vue?vue&type=style&index=0&id=c01e407c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01e407c",
  null
  
)

export default component.exports